export const ACCOUNT_LOCKED = 'account-locked';
export const ADD_CARD = 'add-card';
export const BILLING_ADDRESS = 'billingAddress';
export const CARD_LIST = 'card-list';
export const DEVICE_LOCKED = 'device-locked';
export const ENROLL_CARD = 'enroll-card';
export const REVIEW = 'review';
